import React from 'react';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from './store';
import history from './services/history';
import GlobalStyles from './styles/GlobalStyles';
import Routes from './routes';
import AuthBootstrap from './store/modules/auth/authBootstrap';
import AuthGate from './store/modules/auth/authGate';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <AuthBootstrap>
          <AuthGate>
            <Router history={history}>
              <Routes />
              <GlobalStyles />
              <ToastContainer autoClose={3000} />
            </Router>
          </AuthGate>
        </AuthBootstrap>
      </PersistGate>
    </Provider>
  );
}

export default App;
